import React, { FC, useState, useEffect, PropsWithChildren } from 'react';

import Mobile from '../../pages/Mobile';

const MobileDetect: FC<PropsWithChildren> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  const skip = window.location.pathname.includes('connect-applemusic');

  useEffect(() => {
    if (window.innerWidth <= 640) {
      setIsMobile(true);
    }
  }, []);

  return isMobile && !skip ? <Mobile /> : <React.Fragment>{children}</React.Fragment>;
};

export default MobileDetect;
